export default __webpack_public_path__ + "static/me-1b98dbf419c04acd9146f031b7546ca7.jpeg";